<template>
    <div class="row">
        <div
            v-if="loading"
            class="col-12 mt-5"
            v-loading="true"></div>
        <div v-else class="col-12">
            <card>
                <template slot="header">
                    <div class="d-flex justify-content-between align-items-center">
                        Registration type groups
                        <router-link :to="{ name: 'registration-type-groups-create' }">
                            <el-button class="btn btn-primary">
                                New
                            </el-button>
                        </router-link>
                    </div>
                </template>
                <el-table :data="$store.state.typeGroups">
                    <el-table-column label="Name" prop="name"/>
                    <el-table-column label="Actions">
                        <template slot-scope="props">
                            <router-link :to="{ name: 'registration-type-groups-edit', params: { typeGroupId: props.row._id } }">
                                <el-tooltip content="Edit" placement="top">
                                    <el-button class="btn" title="Edit">
                                        <fa :icon="['fas', 'pen']"/>
                                    </el-button>
                                </el-tooltip>
                            </router-link>
                            <el-tooltip content="Remove" placement="top">
                                <el-button
                                    @click="remove(props.row._id)"
                                    class="btn btn-danger ml-1"
                                    title="Remove">
                                        <fa :icon="['fas', 'trash']"/>
                                </el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </card>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            loading: false
        }
    },
    computed: {
        ...mapState([
            'user',
            'event',
        ])
    },
    mounted () {
        this.getTypeGroups()
        setTimeout(()=>{
            if( !this.user.admin){
                if(!(this.event.adminRoles && this.event.adminRoles[this.user._id] && this.event.adminRoles[this.user._id].viewRegistrationTypes) ){
                    this.$router.push('/dashboard/'+this.$route.params.eventId)
                }
            }
        },1000)
    },
    methods: {
        getTypeGroups: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('getAll', {
                    path: 'type-groups',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
            } catch (e) {
                console.log('erorr getting fields')
            }
            this.loading = false
        },
        remove: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the field?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.$store.commit('SET', ['typeGroups', this.$store.state.typeGroups.filter(field => field._id !== id)])
                    this.$store.dispatch('remove', { path: 'type-groups', id })
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting field')
            }
        }
    }
}
</script>
